export default {"src":"/_next/static/media/calendar.2532566f.svg","height":800,"width":800};